const toJson = (item) => {
    return {
        id: item.id,
        trichYeu: item.trichYeu,
        soVanBan: item.soVanBan,
        ngayBanHanh: item.ngayBanHanh,
        loaiVanBan: item.loaiVanBan,
        linhVuc: item.linhVuc,
        donViBanHanh: item.donViBanHanh,
        nguoiKy: item.nguoiKy,
        file: item.file,
        uploadFiles: item.uploadFiles,
        nguonVanBanId: item.nguonVanBanId,
        nguonVanBanLoai: item.nguonVanBanLoai,
    }
}

const fromJson = (item) => {
    return {
        id: item.id,
        trichYeu: item.trichYeu,
        soVanBan: item.soVanBan,
        ngayBanHanh: item.ngayBanHanh,
        loaiVanBan: item.loaiVanBan,
        linhVuc: item.linhVuc,
        donViBanHanh: item.donViBanHanh,
        nguoiKy: item.nguoiKy,
        file: item.file,
        uploadFiles: item.uploadFiles,
        nguonVanBanId: item.nguonVanBanId,
        nguonVanBanLoai: item.nguonVanBanLoai,
    }
}

const baseJson = () => {
    return {
        id: null,
        trichYeu: null,
        soVanBan: null,
        ngayBanHanh: null,
        loaiVanBan: null,
        linhVuc: null,
        donViBanHanh: null,
        nguoiKy: null,
        file: null,
        uploadFiles: null,
        nguonVanBanId: null,
        nguonVanBanLoai: null,
    }
}

const toListModel = (items) => {
    if (items.length > 0) {
        let data = [];
        items.map((value, index) => {
            data.push(fromJson(value));
        })
        return data ?? [];
    }
    return [];
}

export const vanBanNoiBoModel = {
    toJson, fromJson, baseJson, toListModel
}
